import { requestGet, requestPost } from '@/utils/request';

const api = {
	ITEMS: '/system/cache_items',
	REFRESH: '/system/cache_refresh',
};

export async function cacheItems(queryParams) {
	return requestGet(api.ITEMS, queryParams || {});
}

export async function cacheRefresh(cacheKey) {
	return requestPost(api.REFRESH, { cacheKey });
}
